import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService } from '../services/api.service';

@Component({
  selector: 'app-unitrate',
  templateUrl: './unitrate.component.html',
  styleUrls: ['./unitrate.component.scss']
})
export class UnitrateComponent implements OnInit {

  constructor(private apiService: ApiService, private _snackBar: MatSnackBar) { }
  unitRate: number;
  ngOnInit(): void {
  }
  updateDefaultUnitRate(){

  console.log('test');
  if(this.unitRate){
    this.apiService.setUnitrate(String(this.unitRate)).subscribe((data) => {
      if(data.isSuccess){
        this._snackBar.open('Default unit rate is updated successfully', 'Close', {
          duration: 3000,
        });
      } else {
        this._snackBar.open('Problem in updating unit rate, Please try lateer', 'Close', {
          duration: 3000,
        });
      }
    });
  }
  }
}
